import { register } from 'swiper/element/bundle';
import Swiper from 'swiper';

// Register Swiper
register();

const initSliders = () => {
  const $swiperContainers = document.querySelectorAll('.swiper-teaserList');

  if ($swiperContainers) {
    $swiperContainers.forEach(($swiperContainer) => {
      const initialSlideIndex =
        parseInt($swiperContainer.getAttribute('data-initial-slide'), 10) || 0;

      let centered = false;

      if (initialSlideIndex > 1) {
        centered = true;
      }

      // eslint-disable-next-line no-new
      new Swiper($swiperContainer, {
        centeredSlides: centered,
        initialSlide: initialSlideIndex,
        slidesPerView: 'auto',
        spaceBetween: 0,
      });
    });
  }
};

export default initSliders;

(window as any).initSliders = initSliders;

initSliders();
